import { ISubmission } from "@models/Submission.model";
import {
  doc,
  collection,
  getFirestore,
  DocumentReference,
  CollectionReference,
} from "firebase/firestore";

export const getFormCollectionRef = <T extends Object>(formName: string) =>
  collection(getFirestore(), formName) as CollectionReference<ISubmission<T>>;

export const getFormDocRef = <T extends Object>({
  uid,
  formName,
}: {
  uid: string;
  formName: string;
}) =>
  doc(getFormCollectionRef(formName), uid) as DocumentReference<ISubmission<T>>;
